angular.module('impactx.product').controller('EditViewExtensionCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    '$routeParams',
    'TranslationService',
    'ToolbarService',
    'selectedListItems',
    '$errorHandler',
    '$mdDialog',
    EditViewExtensionCtrl
]);

function EditViewExtensionCtrl($scope, dataGen, BackService, ToastService, $routeParams, TranslationService, ToolbarService, selectedListItems, $errorHandler, $mdDialog) {
    var ctrl = this;

    ctrl.getData = function () {
        initSelection()
        const params = {
            selection: ctrl.selection
        }
        dataGen.postAsForm($scope, params, '/product/productchangeview/viewextension/view').then(function () {
            defineButtons();
        });
    };

    ctrl.save = function (ev) {
        var paramObj = {
            data: $scope.data,
            selection: ctrl.selection
        };
        return dataGen.postAsForm({}, paramObj, '/product/productchangeview/viewextension/save').then(function (response) {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if (response && response.data && response.data.title) {
                // not really errors, but this is the most "Info"-Like-Dialog that is generic.
                $errorHandler.showErrors([response.data], undefined, function () {
                    BackService.back();
                }, true, undefined)
            }
            else {
                BackService.back();
            }
        });
    };

    ctrl.addPriceRule = function (event) {
        dataGen.getData({}, {catId: $scope.data.catId, targetMatchCode: $scope.data.priceListGroup.matchCode}, "/product/pricerule/new").then(function (response) {
            if (response && response.data) {
                $scope.data.priceListGroup.priceRule = response.data;
            }
        });
    };
    
    ctrl.addPriceRule2 = function (event) {
        dataGen.getData({}, {catId: $scope.data.catId, targetMatchCode: $scope.data.priceListGroup2.matchCode}, "/product/pricerule/new").then(function (response) {
            if (response && response.data) {
                $scope.data.priceListGroup2.priceRule = response.data;
            }
        });
    };

    ctrl.canAddPriceRule = function () {
        var priceListGroup = $scope.data.priceListGroup;
        return (!priceListGroup.priceRule || priceListGroup.priceRule.deleted) && !(priceListGroup.fixedPrice && priceListGroup.fixedPrice.value)
    }
    
    ctrl.canAddPriceRule2 = function () {
        var priceListGroup = $scope.data.priceListGroup2;
        return (!priceListGroup.priceRule || priceListGroup.priceRule.deleted) && !(priceListGroup.fixedPrice && priceListGroup.fixedPrice.value)
    }

    ctrl.recalcPriceRule = function (priceRule) {
        var priceLists = [];
        if (priceRule) {
            if (priceRule.source.selected) {
                var currency = impactX.isDefined(priceRule, 'currency.selected.id');
                if (currency) {
                    var sourceGroup = $scope.data.availableSourceGroups.filter(function (entry) {
                        return entry.matchCode === priceRule.source.selected.id;
                    })[0]; // there should only be one, should always be found

                    angular.forEach(sourceGroup.priceLists, function (priceList) {
                        if (!priceList.deleted) {
                            var listCopy = JSON.parse(JSON.stringify(priceList));
                            if (listCopy.currencyValue === currency) {
                                angular.forEach(listCopy.priceListItems, function (pli) {
                                    pli.value.value = pli.value.value * (priceRule.factor.value/100 || 0) + (priceRule.offset.value || 0);
                                });
                            }
                            else {
                                listCopy.priceListItems = [];
                            }
                            priceLists.push(listCopy);
                        }
                    });
                }
            }
        }
        return priceLists;
    }

    ctrl.addPriceList = function (event) {
        $mdDialog.show({
            controller: "AddPriceListCtrl",
            controllerAs: "priceListCtrl",
            templateUrl: "modules/product/templates/addpricelist.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: {
                    proId: ctrl.selection.entries[0].proId,
                    catId: $scope.data.catId,
                    matchCode: $scope.data.priceListGroup.matchCode,
                    changewithoutcheckout: true
                },
                priceGroup: $scope.data.priceListGroup,
                trns: $scope.trns,
                orderUnit: $scope.data.orderUnit,
                allowFracAmounts: $scope.data.allowFractions
            }
        });
    };

    ctrl.toggleFixed = function (event) {
        var priceListGroup = $scope.data.priceListGroup
        if (priceListGroup && priceListGroup.fixedPrice.value) {
            if (priceListGroup.priceRule && !priceListGroup.priceRule.deleted) {
                priceListGroup.priceRule.deleted = true;
                angular.forEach(priceListGroup.priceLists, function (priceList) {
                    priceList.deleted = true;
                });
                ctrl.addPriceList(event);
            }
        }
    }
    
    ctrl.addPriceList2 = function (event) {
        $mdDialog.show({
            controller: "AddPriceListCtrl",
            controllerAs: "priceListCtrl",
            templateUrl: "modules/product/templates/addpricelist.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: {
                    proId: ctrl.selection.entries[0].proId,
                    catId: $scope.data.catId,
                    matchCode: $scope.data.priceListGroup2.matchCode,
                    changewithoutcheckout: true
                },
                priceGroup: $scope.data.priceListGroup2,
                trns: $scope.trns,
                orderUnit: $scope.data.orderUnit,
                allowFracAmounts: $scope.data.allowFractions
            }
        });
    };
    
    ctrl.toggleFixed2 = function (event) {
        var priceListGroup2 = $scope.data.priceListGroup2
        if (priceListGroup && priceListGroup.fixedPrice.value) {
            if (priceListGroup.priceRule && !priceListGroup.priceRule.deleted) {
                priceListGroup.priceRule.deleted = true;
                angular.forEach(priceListGroup.priceLists, function (priceList) {
                    priceList.deleted = true;
                });
                ctrl.addPriceList2(event);
            }
        }
    }

    ctrl.getData();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function initSelection() {
        var selection = [];
        angular.forEach(selectedListItems.getSelectedItems(), function(entry) {
            selection.push({
                proId: entry.proId,
                prgId: entry.prgId
            });
        });
        ctrl.selection = {entries: selection};
    }
}